const shortDateFormatter = new Intl.DateTimeFormat('en-US', {
  month: 'short',
  day: '2-digit',
  year: 'numeric',
});

const shortDateFormatterWithoutYear = new Intl.DateTimeFormat('en-US', {
  month: 'short',
  day: '2-digit',
});

const shortTimeFormatter = new Intl.DateTimeFormat('en-US', {
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
});

export const formatShortDate = (value: string | Date): string => {
  const date = value instanceof Date ? value : new Date(value);
  return shortDateFormatter.format(date);
};

export const formatDateWithoutCurrentYear = (value: string | Date): string => {
  const date = value instanceof Date ? value : new Date(value);
  const currentYear = new Date().getFullYear();
  if (date.getFullYear() === currentYear) {
    return shortDateFormatterWithoutYear.format(date);
  }
  return shortDateFormatter.format(date);
};

export const formatShortTime = (value: string | Date): string => {
  const date = value instanceof Date ? value : new Date(value);
  return shortTimeFormatter.format(date);
};
